import React from "react";
import "./SectionHeader.scss";

interface SectionProps {
  title: string;
  subtitle: string;
  align?: string;
}

const SectionHeader = (props: SectionProps) => {
  return (
    <div className="row">
      <div className="col-lg-12">
        <div
          className={`section-title ${
            props.align === "left" ? "text-left" : "text-center"
          }`}
        >
          <span className="subtitle">{props.subtitle}</span>
          <h2 className="title">{props.title}</h2>
        </div>
      </div>
    </div>
  );
};

export default SectionHeader;
